import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";
import { Crown } from "lucide-react";
import { useBilling } from "../context/BillingContext";

export default function UnlockCelebration() {
  const { unlockCelebration, clearUnlockCelebration } = useBilling();
  const open = !!unlockCelebration;

  useEffect(() => {
    if (!open) return;
    // Haptic zing on mobile
    if (navigator.vibrate) navigator.vibrate([30, 40, 30]);
    const t = setTimeout(() => clearUnlockCelebration(), 3200);
    return () => clearTimeout(t);
  }, [open, clearUnlockCelebration]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[70] flex items-center justify-center pointer-events-none"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          data-testid="unlock-celebration"
        >
          <motion.div
            className="absolute inset-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 0.2] }}
            transition={{ duration: 0.8, times: [0, 0.2, 1] }}
            style={{
              background:
                "radial-gradient(circle at 50% 50%, rgba(255,77,141,0.45), rgba(123,97,255,0.25) 40%, transparent 75%)",
            }}
          />
          {[...Array(24)].map((_, i) => (
            <motion.span
              key={i}
              className="absolute w-1.5 h-1.5 rounded-full"
              initial={{ x: 0, y: 0, opacity: 0, scale: 0 }}
              animate={{
                x: Math.cos((i / 24) * Math.PI * 2) * (120 + (i % 5) * 60),
                y: Math.sin((i / 24) * Math.PI * 2) * (120 + (i % 5) * 60),
                opacity: [0, 1, 0],
                scale: [0, 1.2, 0.4],
              }}
              transition={{ duration: 1.4, delay: 0.05 + (i % 6) * 0.04, ease: "easeOut" }}
              style={{
                background: i % 2 ? "#FF4D8D" : "#00E5FF",
                boxShadow: `0 0 12px ${i % 2 ? "#FF4D8D" : "#00E5FF"}`,
              }}
            />
          ))}
          <motion.div
            initial={{ scale: 0.3, opacity: 0, rotate: -8 }}
            animate={{ scale: 1, opacity: 1, rotate: 0 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", damping: 14, stiffness: 220 }}
            className="relative z-10 text-center"
          >
            <div className="inline-flex w-20 h-20 rounded-3xl bg-gradient-to-br from-[#FF4D8D] to-[#7B61FF] items-center justify-center shadow-[0_0_60px_rgba(255,77,141,0.7)] mb-5">
              <Crown className="w-10 h-10 text-white" />
            </div>
            <p className="text-[10px] uppercase tracking-[0.4em] font-bold text-[#FF4D8D] mb-2">Premium unlocked</p>
            <h2 className="font-display text-4xl sm:text-5xl font-bold text-white">You're in 😈</h2>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
